import React from 'react';
import { rem } from 'polished';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ReactPlayer from 'react-player';
import Img from 'react-image';
import { Icon, Loader } from 'oxyrion-ui/lib';
import { __ } from '../../../../Utils';
import PopUpWrapper from '../../../../Components/PopUpWrapper';
import AlertPopup from '../../../../Components/AlertPopup';
import { marketingTranslate } from '../../CatalogUtils';
import API2 from '../../../../API2';

const Wrapper = styled.div`
  min-height: ${rem(240)};
  padding: ${rem(10)};
  margin: ${rem(10)};
  box-shadow: 0 ${rem(3)} ${rem(5)} 0 rgba(0, 0, 0, 0.16);
  flex-direction: column;
  display: flex;
  background-image: linear-gradient(
    to bottom,
    #f0f0f0,
    #ffffff,
    #ffffff,
    #ffffff,
    #ffffff
  );
`;

const InsideWrapper = styled.div`
  display: flex;
`;

const Image = styled(Img)`
  max-width: ${rem(280)};
  max-height: ${rem(200)};
  z-index: 2;
`;

const VideoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${rem(300)};
`;

const StyledReactPlayer = styled(ReactPlayer)`
  max-width: ${rem(300)};
  max-height: ${rem(200)} !important;
`;

const Title = styled.div`
  margin-bottom: ${rem(6)};
  font-size: ${rem(18)};
  font-weight: bold;
  color: #434245;
`;

const ShortDescription = styled.div`
  font-size: ${rem(14)};
  margin-top: ${rem(4)};
  color: #434245;
  font-weight: 300;
`;

const BottomWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${rem(16)};
`;

const PlayButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: #70af00;
  border: ${rem(1)} solid #70af00;
  padding: ${rem(3)} ${rem(5)};
  border-radius: ${rem(4)};
  cursor: pointer;
  &:hover {
    box-shadow: 0 ${rem(3)} ${rem(5)} 0 rgba(0, 0, 0, 0.16);
  }
`;

const IconWrapper = styled.div`
  transform: rotate(-90deg);
  margin-left: ${rem(16)};
`;

const DownloadIconWrapper = styled.div`
  cursor: pointer;
  width: ${rem(32)};
  height: ${rem(32)};
  display: flex;
  justify-content: center;
  align-items: center;
`;
const DownloadButton = styled.div``;

const DetailVideoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${rem(40)};
  flex-direction: column;
`;

const LongDescriptionWrapper = styled.div`
  flex-direction: column;
  margin-top: ${rem(16)};
  width: ${rem(640)};
  text-align: justify;
`;

const ProductsWrapper = styled.div`
  margin-left: ${rem(12)};
  display: flex;
  flex-direction: column;
`;

const ProductLink = styled.a`
  font-size: 12px;
  color: #70ae04;
  font-weight: bold;
  margin-bottom: ${rem(4)};
  text-decoration: none;
`;

const ReferenceTitle = styled.div`
  color: #434245;
  font-size: ${rem(16)};
  font-weight: bold;
  margin-bottom: ${rem(8)};
`;

const RightSide = styled.div``;

const LeftSide = styled.div`
  width: ${rem(300)};
`;

const baseURL = process.env.REACT_APP_IMAGES_PREFIX;
const videoBasePath = `${process.env.REACT_APP_IMAGES_PREFIX}/v1/video/stream`;

class VideoCard extends React.PureComponent {
  state = {
    playVideo: false,
    videoLoading: false,
    playing: false,
  };

  async downloadVideo() {
    this.setState({
      videoLoading: true,
    });
    try {
      const result = await API2.getB2BMultimediaDownloadAction(
        this.props.data._id,
      );

      this.setState({
        videoLoading: false,
        downloadId: result.url,
      });
    } catch (e) {
      console.log(e);
    }
  }

  async downloadFileWithId(downloadId) {
    window.location.href = downloadId;

    this.setState({
      downloadId: undefined,
    });
  }

  render() {
    const { data } = this.props;
    const { playVideo, videoLoading, downloadId, playing } = this.state;

    return (
      <Wrapper>
        <InsideWrapper>
          <AlertPopup
            alignUnderHeader
            display={downloadId}
            style
            onClose={() =>
              this.setState({
                downloadId: undefined,
              })
            }
            scrollContent
            question
            text={__(`Prajete si uložiť video`)}
            onSubmit={() => this.downloadFileWithId(downloadId)}
            onDismiss={() =>
              this.setState({
                downloadId: undefined,
              })
            }
          />

          {playVideo && (
            <PopUpWrapper
              display={playVideo}
              message={data.name}
              customWidth={700}
              onClose={() =>
                this.setState({
                  playVideo: false,
                  playing: false,
                })
              }
              onEscClose={() =>
                this.setState({
                  playVideo: false,
                  playing: false,
                })
              }
            >
              {playVideo && (
                <DetailVideoWrapper>
                  {data.file && playVideo && (
                    <ReactPlayer
                      url={`${videoBasePath}/${encodeURIComponent(
                        data.file.fullPath,
                      )}`}
                      playing={playing}
                      onPlay={() =>
                        this.setState({
                          playing: true,
                        })
                      }
                      controls
                    />
                  )}
                  <LongDescriptionWrapper>
                    {marketingTranslate(
                      this.props.appLang,
                      data.long_description_translations,
                      data.long_description,
                    )}
                  </LongDescriptionWrapper>
                </DetailVideoWrapper>
              )}
            </PopUpWrapper>
          )}
          <LeftSide>
            <Title>{data.name}</Title>
            <ShortDescription>
              {marketingTranslate(
                this.props.appLang,
                data.short_description_translations,
                data.short_description,
              )}
            </ShortDescription>
            <VideoWrapper>
              {data.view_image ? (
                <Image
                  src={[`${baseURL}/images/370x0/${data.view_image.fullPath}`]}
                  loader={<Loader color="#70af00" />}
                />
              ) : (
                data.file && (
                  <StyledReactPlayer
                    url={`${videoBasePath}/${data.file.fullPath}`}
                  />
                )
              )}
            </VideoWrapper>
          </LeftSide>
          <RightSide>
            {data.used_products.length > 0 && (
              <ProductsWrapper>
                <ReferenceTitle style={{ fontSize: rem(14) }}>
                  {__('Použité produkty')}
                </ReferenceTitle>
                {data.used_products.map(p => (
                  <ProductLink
                    target="_blank"
                    href={`../catalog/list/${p.catalogProduct._id}`}
                  >
                    {p.catalogProduct.name}
                  </ProductLink>
                ))}
              </ProductsWrapper>
            )}
          </RightSide>
        </InsideWrapper>

        <BottomWrapper>
          <PlayButton
            onClick={() =>
              this.setState({
                playVideo: true,
              })
            }
          >
            {__('Prehrať')}
            <IconWrapper>
              <Icon name="arrow-down" color="#70af00" />
            </IconWrapper>
          </PlayButton>
          <DownloadButton onClick={() => this.downloadVideo()}>
            <DownloadIconWrapper title={__('Stiahnúť')}>
              {videoLoading ? (
                <Loader />
              ) : (
                <Icon name="file-download" size="l" color="#70af00" />
              )}
            </DownloadIconWrapper>
          </DownloadButton>
        </BottomWrapper>
      </Wrapper>
    );
  }
}

VideoCard.propTypes = {
  data: PropTypes.shape({
    _id: PropTypes.string,
  }).isRequired,
};

VideoCard.defaultProps = {};

export default VideoCard;



// WEBPACK FOOTER //
// ./src/Containers/ProductCatalog/Components/VideoCard/index.jsx